import { InsightsResponse } from "./services/episode.service";

export const EPISODE_CONTENT_HUB_LABEL = "Content Hub";

export const EPISODE_TAB_LABELS: Record<"preview" | "insights", string> = {
  preview: "Preview",
  insights: EPISODE_CONTENT_HUB_LABEL,
};

export const EPISODE_INSIGHT_CATEGORY_LABELS: Record<
  keyof InsightsResponse,
  string
> = {
  quotes: "Quotes",
  titles: "Headlines",
  tweets: "Social Posts",
  chapters: "Chapters",
  keywords: "Keywords",
  blog_post: "Blog Post",
  newsletter: "Newsletter",
  linkedin_posts: "LinkedIn Posts",
  descriptions: "Episode Descriptions",
};

export const getInsightCategoryLabel = (key: string) => {
  return (
    EPISODE_INSIGHT_CATEGORY_LABELS[
      key as keyof typeof EPISODE_INSIGHT_CATEGORY_LABELS
    ] ?? key
  );
};
